<template>
  <m-dialog ref="dlgPengimbasan" :btnsave="false" @save="save" title="Ubah Tautan Video Pengimbasan">
    <v-row row wrap justify="center" align="center">
      <v-col cols="12" sm="12" md="10" lg="8" xl="8">
        <v-form autocomplete="false" @submit.prevent data-vv-scope="form" lazy-validation>
          <v-card flat class="pa-5 mb-5">
            <v-card-text>
              <v-row wrap>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    outlined
                    dense
                    autofocus
                    prepend-inner-icon="mdi-youtube"
                    autocomplete="false"
                    name="Tautan"
                    placeholder="Letakkan tautan pengimbasan Anda pada form berikut"
                    label="Tautan Video Pengimbasan"
                    v-model="pengimbasan.url"
                    hint="Tombol kirim akan aktif jika tautan video yang Anda masukkan sudah benar"
                    persistent-hint
                    data-vv-name="nama"
                    data-vv-as="Tautan video pengimbasan"
                    v-validate="{ url: { require_protocol: true }, required: true }"
                    :error-messages="errors.collect('form.nama')"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <span class="black--text">Contoh penulisan tautan yang benar: </span>
                  <p class="blue--text my-0 py-0">https://www.youtube.com/watch?v=xaeda</p>
                  <p class="blue--text my-0 py-0">https://www.youtu.be.com/F4AZe</p>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer><m-button :disabled="is_disable" right text-button="Kirim" icon="mdi-send" action="save" @save="save"></m-button>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
import { ALERT_INFO } from "@/const";
export default {
  $_veeValidate: {
    validator: "new"
  },
  components: {},

  data() {
    return {
      id_kelas: null,
      step: 1,
      pengimbasan: {
        url: ""
      },
      is_disable: false,
      defKelas: {
        nama: ""
      },

      alert: ALERT_INFO
    };
  },
  methods: {
    // eslint-disable-next-line
    open(obj) {
      if (obj) {
        this.pengimbasan = obj;
        this.id_kelas = obj.id;
      }
      this.loadStatusPengimbasan();
      let x = this.$refs.dlgPengimbasan.open();
      this.$validator.reset();
      return x;
    },

    loadStatusPengimbasan() {
      return this.$store
        .dispatch("kelas/statusPengimbasan", {
          instansi_id: this.instansi_id
        })
        .then(res => {
          this.pengimbasan = res[0];
          if (res.length > 0) {
            this.statusUnggah = true;
            // jika status nya 2 (approved), url dicatat sebagai valid url
            if (res[0].status == 2) {
              this.validUrl = true;
            } else {
              // jika tidak valid tampilkan notifikasi
              this.validUrl = false;
            }
          } else {
            this.statusUnggah = false;
          }
        })
        .catch(e => e);
    },

    // eslint-disable-next-line
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          this.pengimbasan.kelas_id = this.id_kelas;

          return this.$store
            .dispatch("kelas/inputVideoPengimbasan", {
              instansi_id: this.instansi_id,
              obj: this.pengimbasan
            })
            .then(res => {
              if (res) {
                this.$info("Unggah tautan video berhasil");
                this.$refs.dlgPengimbasan.resolve();
                return res;
              }
            })
            .catch(e => e);
        })
        .catch(e => e);
    }
  },
  watch: {
    "pengimbasan.url"(n) {
      if (typeof n != "undefined") {
        var match_1 = n.match(/.youtube.*/);
        var match_2 = n.match(/.youtu.be.*/);

        if (match_1) {
          this.is_disable = false;
        } else if (match_2) {
          this.is_disable = false;
        } else {
          this.is_disable = true;
        }
      }
    }
  }
};
</script>
